// Plan ▸ Beats: the beat sheet above the scenes — acts, beats, the scenes assigned to each, and the tray of the rest.
export { BeatBoardPage as component, BeatControls as headerControls } from '../../views/plan/BeatBoard.tsx';
export const room = 'plan';
export const page = 'beats';
export const title = 'Beats';
export const help = 'beats';
